var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "site-accordion", style: _vm.containerStyle },
    _vm._l(_vm.panels, function (panel, idx) {
      return _c(
        "div",
        {
          key: panel.id,
          staticClass: "site-accordion__panel",
          class: {
            "site-accordion__panel--open": _vm.isOpen(idx),
            "site-accordion__panel--after-open": idx > 0 && _vm.isOpen(idx - 1),
          },
          style: _vm.panelStyle,
        },
        [
          _c(
            "button",
            {
              staticClass: "site-accordion__trigger",
              style: _vm.triggerStyle,
              attrs: { "aria-expanded": _vm.isOpen(idx) ? "true" : "false" },
              on: {
                click: function ($event) {
                  return _vm.toggle(idx)
                },
              },
            },
            [
              panel.icon
                ? _c("i", {
                    staticClass: "site-accordion__panel-icon",
                    class: "fa fa-" + panel.icon,
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "site-accordion__panel-title" }, [
                _vm._v(_vm._s(panel.title || "Panel " + (idx + 1))),
              ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa site-accordion__chevron",
                class: _vm.isOpen(idx) ? "fa-chevron-up" : "fa-chevron-down",
                style: _vm.isOpen(idx) ? { color: _vm.accentColor } : {},
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "site-accordion__body",
              class: { "site-accordion__body--open": _vm.isOpen(idx) },
            },
            [
              _c(
                "div",
                {
                  staticClass: "site-accordion__body-inner",
                  style: _vm.bodyStyle,
                },
                _vm._l(panel.blocks || [], function (childBlock) {
                  return _c("site-block-renderer", {
                    key: childBlock.id,
                    attrs: { block: childBlock },
                  })
                }),
                1
              ),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }